export function formatOptionalCurrency(value: number | null, currency?: string | null): string {
  if (value === null) return 'None';
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency?.trim() || 'USD',
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    // An unrecognized/malformed currency code from extraction should not
    // blank out the value -- fall back to the numeric amount with the raw
    // code attached, still legible for review.
    return currency ? `${value.toFixed(2)} ${currency}` : value.toFixed(2);
  }
}
